import React from 'react';
import { Formik, Field, Form } from 'formik';
// import Button from "@elements/redesign/Button/Button";
import ISelect from "@elements/redesign/Select/Select";
import classNames from "classnames";
import { PhonePropsType, usePhone } from "./index";
import { positiveNumberPattern } from "@utils/constants";
import { useTranslations } from 'next-intl';
import LoadingIcon from '@svg/loadingIcon';
import Button from '@elements/button';

const Phone: React.FC<PhonePropsType> = (props) => {
  const t = useTranslations();
  const { validationSchema, initialValues, countryList, onSubmit, isLoading } = usePhone(props);

  if (!countryList.length) {
    return <div className='flex-1 flex w-full items-center justify-center'>
      <LoadingIcon />
    </div>;
  }

  return (
    <Formik
      enableReinitialize
      validateOnBlur={true}
      validateOnChange={true}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        onSubmit(values)
      }}
    >
      {({ isValid, handleBlur, values, errors, setFieldValue, setFieldTouched, touched }) => (
        <Form className="w-full flex flex-col items-center flex-1">
          <div className="w-full flex flex-col gap-2 items-center flex-1">
            <h3 className="text-black text-lg font-bold leading-8 text-center">{t("client_phoneverify_enterphone")}</h3>
            <p className="text-mui-text-secondary text-center text-[13px] font-medium leading-5">{t("client_phoneverify_enterphonedesc")}</p>
            <div className="w-full flex items-start gap-3 mt-3 " dir="ltr">
              {values.countryCode && (
                <ISelect
                  onChange={(e: any) => { setFieldValue('countryCode', e); setFieldValue('phoneNumber', ""); setFieldTouched("phoneNumber", false) }}
                  initialCountryCode={values.countryCode}
                  countryList={countryList}
                />
              )}
              <div className="flex flex-col flex-1">
                <Field
                  name="phoneNumber"
                  placeholder={t("client_general_phonenumber")}
                  className={classNames("h-14 px-3 border placeholder:text-mui-text-disabled text-mui-text-primary tracking-[0.15px] rounded-2xl outline-none w-full", errors.phoneNumber && touched.phoneNumber ? "focus:border-mui-error-main border-mui-error-main" : "focus:border-mui-primary-main border-[#0000003B]")}
                  type="string"
                  inputMode="numeric"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const v = e.target.value;
                    if (new RegExp(positiveNumberPattern, "i").test(v) || !v) {
                      setFieldValue("phoneNumber", v);
                    }
                  }}
                  onBlur={handleBlur}
                />
                {errors.phoneNumber && touched.phoneNumber && <p className="text-mui-error-main text-xs mt-1 w-full px-3 text-start">{errors.phoneNumber}</p>}
              </div>
            </div>
          </div>
          <div className="w-full grid grid-cols-1 gap-4 mt-10">
            <Button
              theme="blue"
              className="!font-bold !h-12 rounded-full text-sm "
              type="submit"
              isDisabled={!isValid || !values.phoneNumber || !values.countryCode || isLoading}
              loading={isLoading}
            >
              {t("client_buttons_continue")}
            </Button>
            {/* <Button
              theme="primary"
              label={t("client_buttons_continue")}
              size="small"
              className="!font-bold !h-12"
              type="submit"
              disabled={!isValid || !values.phoneNumber || !values.countryCode}
            /> */}
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default Phone;